import * as React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../reducers';
import { Dispatch } from 'redux';
import sum from 'lodash/sum';
import { updateAdditionalNotes, IFilterStateAction } from '../../filter/actions/filter-actions';

export interface StateToProps {
    additionalNotesTitle: string,
    additionalNotesPlaceholder: string,
    additionalNotes: string;
};

interface DispatchToProps {
    updateAdditionalNotes: (event) => any;
}

interface IAdditionalNotesState {
    inputText: string;
}

type AdditionalNotesProps = StateToProps & DispatchToProps;

class AdditionalNotes extends React.PureComponent<AdditionalNotesProps, IAdditionalNotesState> {
    constructor(props: AdditionalNotesProps) {
        super(props);
        this.state = {
            inputText: ""
        };

    }
    handleChange = (event) => {
        this.setState({ inputText: event.target.value });
    }
    render() {
        var charsPerLine = 90;

        var textbox = document.getElementById('txtArea');
        if (textbox != null) {
            var textboxWidth = textbox.getBoundingClientRect().width;
            var numberOfRows = 1;
            var pxPerCharacter = 12;

            charsPerLine = Math.floor(textboxWidth / pxPerCharacter);
        }

        var numberOfLongLines = sum(this.props.additionalNotes.split('\n').filter(line => line.length >= charsPerLine)
            .map(l => Math.ceil(l.length / charsPerLine)));
        var numberOfNewLines = this.props.additionalNotes.split('\n').length - 1;

        var totalLines = numberOfLongLines + numberOfNewLines;
        return (

            <div className="additional-notes">

                <label htmlFor="txtArea">{this.props.additionalNotesTitle}</label>
                <textarea id="txtArea" placeholder={this.props.additionalNotesPlaceholder}
                    rows={totalLines > 0 ? totalLines : 2}
                    onChange={this.props.updateAdditionalNotes}
                    value={this.props.additionalNotes}></textarea>
            </div>
        );
    }
}

function mapStateToProps(state: IAppState): StateToProps {
    return {
        additionalNotesPlaceholder: state.appSettingsModel.additionalNotesPlaceholder,
        additionalNotesTitle: state.appSettingsModel.additionalNotesTitle,
        additionalNotes: state.additionalSeatingOptionModel.additionalNotes
    }
}

function mapDispatchToProps(dispatch: Dispatch<IFilterStateAction>): DispatchToProps {
    return {
        updateAdditionalNotes: (event) => dispatch(updateAdditionalNotes(event.target.value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalNotes)
